import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg36Userplaceholder = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        fillOpacity: 0.1,
        d: "M0 0h36v36H0z"
      }), /*#__PURE__*/jsx("path", {
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        strokeWidth: 1.125,
        d: "M18 18.501c-2.07 0-3.942.454-5.265 1.32-1.14.746-1.86 1.806-1.86 3.15 0 .418.173.797.476 1.067.314.281.76.444 1.289.446l10.977-.006c.42 0 .799-.181 1.062-.558.29-.414.446-1.027.446-1.84 0-.442-.172-.859-.466-1.241-.347-.451-.86-.852-1.49-1.192C21.846 18.934 20.017 18.5 18 18.5zm-.04-7.063a2.545 2.545 0 0 0-1.802 4.346c.464.464 1.106.746 1.866.746.703 0 1.34-.285 1.8-.745a2.54 2.54 0 0 0-.01-3.604 2.63 2.63 0 0 0-1.855-.744z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg36Userplaceholder$1 = Svg36Userplaceholder;

export { Svg36Userplaceholder$1 as default };
